module.exports = __webpack_public_path__ + "static/media/Avatar_14.a72cab8f.svg";